import { Container, Row, Col } from "react-bootstrap";
import Typewriter from 'typewriter-effect';
import { Users, TrendingUp, Award, ChevronRight, Handshake, DollarSign, Target } from 'lucide-react';

function ContactoDistribuidor() {
    const beneficios = [
        {
            icon: <DollarSign size={32} />,
            titulo: "Mejores Precios",
            descripcion: "Precios especiales para distribuidores"
        },
        {
            icon: <Award size={32} />,
            titulo: "Marcas Líderes",
            descripcion: "Productos de calidad reconocida"
        },
        {
            icon: <Handshake size={32} />,
            titulo: "Soporte Garantizado",
            descripcion: "Asesoría y capacitación constante"
        },
        {
            icon: <Target size={32} />,
            titulo: "Crecimiento",
            descripcion: "Expande tu negocio con nosotros"
        }
    ];

    return (
        <section className="distribuidor-section">
            {/* Fondo decorativo animado */}
            <div className="distribuidor-background">
                <div className="distribuidor-shape distribuidor-shape-1"></div>
                <div className="distribuidor-shape distribuidor-shape-2"></div>
                <div className="distribuidor-shape distribuidor-shape-3"></div>
                <div className="distribuidor-pattern"></div>
            </div>

            <Container className="distribuidor-container">
                <Row className="align-items-center g-5">
                    {/* Columna izquierda - Contenido principal */}
                    <Col lg={8} className="distribuidor-content">
                        {/* Badge */}
                        <div className="distribuidor-badge">
                            <Users size={20} />
                            <span>Red de Distribuidores</span>
                        </div>

                        {/* Título con Typewriter */}
                        <div className="distribuidor-typewriter">
                            <h2 className="distribuidor-title">
                                <Typewriter
                                    onInit={(typewriter) => {
                                        typewriter
                                            .typeString('¿Tienes un negocio y te interesa vender nuestros productos? Únete a nuestra red de Distribuidores Ferreteros Empieza a generar más ingresos con nuestras marcas líderes')
                                            .pauseFor(2000)
                                            .deleteAll()
                                            // .typeString('Únete a nuestra red de Distribuidores Ferreteros')
                                            // .pauseFor(2000)
                                            // .deleteAll()
                                            // .typeString('Empieza a generar más ingresos con nuestras marcas líderes')
                                            // .pauseFor(2000)
                                            // .deleteAll()
                                            .start();
                                    }}
                                    options={{
                                        loop: true,
                                        delay: 50,
                                        deleteSpeed: 30,
                                    }}
                                />
                            </h2>
                        </div>

                        {/* Subtítulo */}
                        <p className="distribuidor-subtitle">
                            Conviértete en parte de nuestra familia de distribuidores y accede a beneficios exclusivos
                        </p>

                        {/* Beneficios en mini cards */}
                        <div className="distribuidor-beneficios-grid">
                            {beneficios.map((beneficio, index) => (
                                <div 
                                    key={index} 
                                    className="beneficio-mini-card"
                                    style={{ animationDelay: `${index * 0.1}s` }}
                                >
                                    <div className="beneficio-icon">
                                        {beneficio.icon}
                                    </div>
                                    <div className="beneficio-info">
                                        <h4>{beneficio.titulo}</h4>
                                        <p>{beneficio.descripcion}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Col>

                    {/* Columna derecha - CTA y Stats */}
                    <Col lg={4} className="distribuidor-cta-column">
                        {/* Card de CTA */}
                        <div className="distribuidor-cta-card">
                            <div className="cta-icon-wrapper">
                                <TrendingUp size={68} />
                            </div>
                            
                            <h3 className="cta-title">
                                Haz Crecer tu Negocio
                            </h3>
                            
                            <p className="cta-description">
                                Descubre todos los requisitos y beneficios de ser distribuidor autorizado
                            </p>

                            {/* Stats rápidas */}
                            <div className="cta-stats">
                                <div className="stat-quick">
                                    <span className="stat-number">+100</span>
                                    <span className="stat-label">Distribuidores</span>
                                </div>
                                <div className="stat-divider"></div>
                                <div className="stat-quick">
                                    <span className="stat-number">7</span>
                                    <span className="stat-label">Marcas</span>
                                </div>
                            </div>

                            {/* Botón principal */}
                            <a href="/distribuidor" className="btn-distribuidor-primary">
                                <span>Conoce los Requisitos</span>
                                <ChevronRight size={20} />
                            </a>

                            {/* Link secundario */}
                            {/* <a href="/contacto" className="btn-distribuidor-secondary">
                                Contactar Ahora
                            </a> */}
                        </div>

                        {/* Indicadores adicionales */}
                        {/* <div className="distribuidor-trust-badges">
                            <div className="trust-badge">
                                <Award size={20} />
                                <span>Certificación Oficial</span>
                            </div>
                            <div className="trust-badge">
                                <Handshake size={20} />
                                <span>Soporte Garantizado</span>
                            </div>
                        </div> */}
                    </Col>
                </Row>
            </Container>

            {/* Elementos flotantes decorativos */}
            <div className="distribuidor-floating-elements">
                <div className="floating-icon floating-icon-1">
                    <Users size={40} />
                </div>
                <div className="floating-icon floating-icon-2">
                    <TrendingUp size={40} />
                </div>
                <div className="floating-icon floating-icon-3">
                    <Award size={40} />
                </div>
            </div>
        </section>
    );
}

export default ContactoDistribuidor;